import * as yup from 'yup';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';
import { healthContractBaseSchema } from '@/features/Contract/Health/contractBaseSchema';

export const contractSchema = healthContractBaseSchema;

export type ContractStore = yup.Asserts<typeof contractSchema>;

export const usePkvContractStore = genericStoreFactory(
  () => healthContractBaseSchema.getDefault(),
  'PkvContractStore',
);
